<section class="simulation grid-container grid-container--section no-gutter-mobile" data-overload-controller="AdhesionPegaseCtrl">
    <app-stepper-component [currentStepId]="'etude_dossier'"></app-stepper-component>

    <div class="simulation__group">
        <div>
            <section class="appointment-consent">
                <div class="appointment-consent__content">
                    <div class="appointment-consent__content__header">
                        <div class="appointment-consent__content__header__title">
                            {{ 'appointment.appointmentconsent.title' | i18n }}
                        </div>
                        <div class="appointment-consent__content__header__image"></div>
                    </div>

                    <div class="appointment-consent__description">
                        <div class="appointment-consent__description--descriptionBackground">
                            {{ 'appointment.appointmentconsent.description' | i18n }}
                            <div class="choice-box choice-box--inline-left" style="margin: 20px 0">
                                <div class="appointment-consent__checkboxPos">
                                    <input id="arm-authorization" class="choice" type="checkbox" (change)="appointmentConsentCheckBox($event)" [(ngModel)]="appointmentConsentChecked" />
                                    <label class="choice-box__label acceptance-box__label appointment-consent__checkboxPos--checkboxLabel" for="arm-authorization">
                                        <span>{{ 'appointment.appointmentconsent.checkbox.text' | i18n }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="simulation__buttons">
                    <button
                        type="button"
                        class="button button--primary button--next float-right"
                        [disabled]="!appointmentConsentChecked || pageLoading"
                        (click)="validateConsent()"
                        [ngClass]="{ 'icon--loading': consentLoading || pageLoading }"
                    >
                        {{ 'appointment.apppointmentconsent.buttons.next' | i18n }}
                    </button>

                    <button type="button" class="button--grey button--previous-list" routerLink="/souscription/document-medicale/document-list">
                        {{ 'appointment.apppointmentconsent.buttons.return' | i18n }}
                    </button>
                </div>
            </section>
        </div>
    </div>
</section>
<app-error-small-modal [title]="'global.popin.error.title'" [content]="'global.errors.unknown'" [closeButton]="'global.close'" [(visibility)]="showErrorModal"> </app-error-small-modal>
